import React, {useState} from 'react';
import {Icon, message, Modal, Popover} from 'antd';
import {MODALS, PASSWORD_HINT, TIMEOUT} from 'utils/constants';
import {useDispatch, useSelector} from 'react-redux';
import {setActiveModal} from '../../store/global/actions';
import './ChangePasswordModal.scss';
import GlobalApi from 'services/Global';
import {storage} from '../../services/config/storage';
import {validatePassword} from '../../utils/passwordValidator';

export const ChangePasswordModal = () => {
    const dispatch = useDispatch();
    const {activeModal} = useSelector(({global}) => global);
    let user = storage.fetch.userDetails();

    const [data, setData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    });
    const onAccept = async () => {
        if (data?.newPassword !== data?.confirmPassword) {
            message.error("New passwords doesn't match.", TIMEOUT);
            return;
        }
        let patternMath = validatePassword(data?.newPassword, user?.emailId);
        if (!patternMath.valid) {
            message.error(patternMath.errorMessage, TIMEOUT);
        } else {
            const payload = {
                emailId: user?.emailId,
                oldPassword: data?.oldPassword,
                newPassword: data?.newPassword,
            };
            const res = await GlobalApi.changePassword(payload);
            if (res) {
                message.success(res.message);
            }
            dispatch(setActiveModal(null));
        }
    };

    const onDecline = async () => {
        dispatch(setActiveModal(null));
    };

    const passwordHint = (
        <span className="password-hint">
            <PASSWORD_HINT />
        </span>
    );

    return (
        <>
            <Modal
                centered={window.innerWidth > 1024 ? true : false}
                title={
                    <div>
                        <div style={{color: '#A3A2A2'}}>
                            DBS Insights Direct - Change Password
                        </div>
                    </div>
                }
                visible={activeModal === MODALS.CHANGE_PASSWORD}
                closable={false}
                onCancel={() => onDecline()}
                destroyOnClose
                cancelText="Skip"
                okText="Change Password"
                onOk={() => onAccept()}
                wrapClassName="terms-modal"
                maskStyle={{
                    backdropFilter: 'blur(6px)',
                    background: '#fff0',
                }}
                maskClosable={false}
            >
                <section>
                    <div className="change-password">
                        <h3>Old Password:</h3>
                        <input
                            prefix={
                                <Icon
                                    type="lock"
                                    style={{color: 'rgba(0,0,0,.25)'}}
                                />
                            }
                            type="password"
                            value={data?.oldPassword}
                            className="change-password--old"
                            onChange={(e) =>
                                setData({...data, oldPassword: e.target.value})
                            }
                        />
                    </div>
                    <div className="change-password">
                        <h3>New Password:</h3>
                        <Popover
                            style={{width: 500}}
                            content={passwordHint}
                            trigger="hover"
                            open="true"
                            placement="bottom"
                        >
                            <input
                                prefix={
                                    <Icon
                                        type="lock"
                                        style={{color: 'rgba(0,0,0,.25)'}}
                                    />
                                }
                                type="password"
                                value={data?.newPassword}
                                className="change-password--old"
                                onChange={(e) =>
                                    setData({
                                        ...data,
                                        newPassword: e.target.value,
                                    })
                                }
                            />
                        </Popover>
                    </div>
                    <div className="change-password">
                        <h3>Confirm Password:</h3>
                        <input
                            prefix={
                                <Icon
                                    type="lock"
                                    style={{color: 'rgba(0,0,0,.25)'}}
                                />
                            }
                            type="password"
                            value={data?.confirmPassword}
                            className="change-password--old"
                            onChange={(e) =>
                                setData({
                                    ...data,
                                    confirmPassword: e.target.value,
                                })
                            }
                        />
                    </div>
                </section>
            </Modal>
        </>
    );
};
